import { Status } from 'api/common/statuses'
import { Notice } from 'api/common/types'
import { noticeOneAPI } from 'api/notice'
import Footer from 'components/Footer'
import Header from 'components/Header'
import * as React from 'react'
import { Button, Card } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { dateFormatter } from 'utilities/typeUtility'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const [notice, setNotices] = React.useState<Notice>({ content: '', date: new Date(), noticeId: 0, title: '' })
  const { noticeId } = useParams()
  React.useEffect(() => {
    if (!noticeId || !Number(noticeId)) {
      navigate('/notificationList')
    } else {
      noticeOneAPI(Number(noticeId), (status, result) => {
        if (status === Status.Success) {
          setNotices(result)
        } else {
          navigate('/notificationList')
        }
      })
    }
  }, [navigate, noticeId])
  return (
    <>
      <Header title="お知らせ詳細" />
      <main>
        <section className="mx-4 my-5">
          <Card body className="border-0 mt-3">
            <div className="item-date">{dateFormatter(notice.date, 'yyyy/MM/dd')}</div>
            <div className="font-18 fw-bold mt-1">{notice.title}</div>
            <div className="mt-3" dangerouslySetInnerHTML={{ __html: notice.content }}></div>
          </Card>
          <div className="mt-4 text-center">
            <Button variant="link" href="/notificationList">
              お知らせ一覧に戻る
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
